/*-------------------------------------------------------------------------------*/
/* MEMBERS                                                                       */
/*-------------------------------------------------------------------------------*/

// FETCH_ORGANIZATION_MEMBERS
export const FETCH_ORGANIZATION_MEMBERS_REQUEST = 'Organization/FETCH_ORGANIZATION_MEMBERS_REQUEST';
export const FETCH_ORGANIZATION_MEMBERS_RESPONSE =
  'Organization/FETCH_ORGANIZATION_MEMBERS_RESPONSE';
export const FETCH_ORGANIZATION_MEMBERS_ERROR = 'Organization/FETCH_ORGANIZATION_MEMBERS_ERROR';

// CREATE_ORGANIZATION_MEMBER
export const CREATE_ORGANIZATION_MEMBER_REQUEST = 'Organization/CREATE_ORGANIZATION_MEMBER_REQUEST';
export const CREATE_ORGANIZATION_MEMBER_RESPONSE =
  'Organization/CREATE_ORGANIZATION_MEMBER_RESPONSE';
export const CREATE_ORGANIZATION_MEMBER_ERROR = 'Organization/CREATE_ORGANIZATION_MEMBER_ERROR';

// UPDATE_ORGANIZATION_MEMBER
export const UPDATE_ORGANIZATION_MEMBER_REQUEST = 'Organization/UPDATE_ORGANIZATION_MEMBER_REQUEST';
export const UPDATE_ORGANIZATION_MEMBER_RESPONSE =
  'Organization/UPDATE_ORGANIZATION_MEMBER_RESPONSE';
export const UPDATE_ORGANIZATION_MEMBER_ERROR = 'Organization/UPDATE_ORGANIZATION_MEMBER_ERROR';

// UPDATE_ORGANIZATION_MEMBERSHIP
export const UPDATE_ORGANIZATION_MEMBERSHIP_REQUEST =
  'Organization/UPDATE_ORGANIZATION_MEMBERSHIP_REQUEST';
export const UPDATE_ORGANIZATION_MEMBERSHIP_RESPONSE =
  'Organization/UPDATE_ORGANIZATION_MEMBERSHIP_RESPONSE';
export const UPDATE_ORGANIZATION_MEMBERSHIP_ERROR =
  'Organization/UPDATE_ORGANIZATION_MEMBERSHIP_ERROR';

// REMOVE_ORGANIZATION_MEMBER
export const REMOVE_ORGANIZATION_MEMBER_REQUEST = 'Organization/REMOVE_ORGANIZATION_MEMBER_REQUEST';
export const REMOVE_ORGANIZATION_MEMBER_RESPONSE =
  'Organization/REMOVE_ORGANIZATION_MEMBER_RESPONSE';
export const REMOVE_ORGANIZATION_MEMBER_ERROR = 'Organization/REMOVE_ORGANIZATION_MEMBER_ERROR';

// SEND_PASSWORD_RESET
export const SEND_PASSWORD_RESET_REQUEST = 'Organization/SEND_PASSWORD_RESET_REQUEST';
export const SEND_PASSWORD_RESET_RESPONSE = 'Organization/SEND_PASSWORD_RESET_RESPONSE';
export const SEND_PASSWORD_RESET_ERROR = 'Organization/SEND_PASSWORD_RESET_ERROR';

// DISABLE_TWO_FACTOR_AUTHENTICATION
export const DISABLE_TWO_FACTOR_AUTHENTICATION_REQUEST =
  'Organization/DISABLE_TWO_FACTOR_AUTHENTICATION_REQUEST';
export const DISABLE_TWO_FACTOR_AUTHENTICATION_RESPONSE =
  'Organization/DISABLE_TWO_FACTOR_AUTHENTICATION_RESPONSE';
export const DISABLE_TWO_FACTOR_AUTHENTICATION_ERROR =
  'Organization/DISABLE_TWO_FACTOR_AUTHENTICATION_ERROR';

/*-------------------------------------------------------------------------------*/
/* PROJECTS                                                                      */
/*-------------------------------------------------------------------------------*/

// FETCH_ORGANIZATION_PROJECTS
export const FETCH_ORGANIZATION_PROJECTS_REQUEST =
  'Organization/FETCH_ORGANIZATION_PROJECTS_REQUEST';
export const FETCH_ORGANIZATION_PROJECTS_RESPONSE =
  'Organization/FETCH_ORGANIZATION_PROJECTS_RESPONSE';
export const FETCH_ORGANIZATION_PROJECTS_ERROR = 'Organization/FETCH_ORGANIZATION_PROJECTS_ERROR';

/*-------------------------------------------------------------------------------*/
/* ROLES                                                                         */
/*-------------------------------------------------------------------------------*/

// FETCH_ORGANIZATION_ROLES
export const FETCH_ORGANIZATION_ROLES_REQUEST = 'Organization/FETCH_ORGANIZATION_ROLES_REQUEST';
export const FETCH_ORGANIZATION_ROLES_RESPONSE = 'Organization/FETCH_ORGANIZATION_ROLES_RESPONSE';
export const FETCH_ORGANIZATION_ROLES_ERROR = 'Organization/FETCH_ORGANIZATION_ROLES_ERROR';

// CREATE_ORGANIZATION_ROLE
export const CREATE_ORGANIZATION_ROLE_REQUEST = 'Organization/CREATE_ORGANIZATION_ROLE_REQUEST';
export const CREATE_ORGANIZATION_ROLE_RESPONSE = 'Organization/CREATE_ORGANIZATION_ROLE_RESPONSE';
export const CREATE_ORGANIZATION_ROLE_ERROR = 'Organization/CREATE_ORGANIZATION_ROLE_ERROR';

// UPDATE_ORGANIZATION_ROLE
export const UPDATE_ORGANIZATION_ROLE_REQUEST = 'Organization/UPDATE_ORGANIZATION_ROLE_REQUEST';
export const UPDATE_ORGANIZATION_ROLE_RESPONSE = 'Organization/UPDATE_ORGANIZATION_ROLE_RESPONSE';
export const UPDATE_ORGANIZATION_ROLE_ERROR = 'Organization/UPDATE_ORGANIZATION_ROLE_ERROR';

/*-------------------------------------------------------------------------------*/
/* TEAMS                                                                         */
/*-------------------------------------------------------------------------------*/

// FETCH_ORGANIZATION_TEAMS
export const FETCH_ORGANIZATION_TEAMS_REQUEST = 'Organization/FETCH_ORGANIZATION_TEAMS_REQUEST';
export const FETCH_ORGANIZATION_TEAMS_RESPONSE = 'Organization/FETCH_ORGANIZATION_TEAMS_RESPONSE';
export const FETCH_ORGANIZATION_TEAMS_ERROR = 'Organization/FETCH_ORGANIZATION_TEAMS_ERROR';

/*-------------------------------------------------------------------------------*/
/* PERMISSIONS                                                                   */
/*-------------------------------------------------------------------------------*/

// FETCH_PERMISSIONS
export const FETCH_PERMISSIONS_REQUEST = 'Organization/FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_RESPONSE = 'Organization/FETCH_PERMISSIONS_RESPONSE';
export const FETCH_PERMISSIONS_ERROR = 'Organization/FETCH_PERMISSIONS_ERROR';

/*-------------------------------------------------------------------------------*/
/* DELIVERY TARGETS                                                              */
/*-------------------------------------------------------------------------------*/

// FETCH_DELIVERY_TARGETS
export const FETCH_DELIVERY_TARGETS_REQUEST = 'Organization/FETCH_DELIVERY_TARGETS_REQUEST';
export const FETCH_DELIVERY_TARGETS_RESPONSE = 'Organization/FETCH_DELIVERY_TARGETS_RESPONSE';
export const FETCH_DELIVERY_TARGETS_ERROR = 'Organization/FETCH_DELIVERY_TARGETS_ERROR';

// CREATE_DELIVERY_TARGET
export const CREATE_DELIVERY_TARGET_REQUEST = 'Organization/CREATE_DELIVERY_TARGET_REQUEST';
export const CREATE_DELIVERY_TARGET_RESPONSE = 'Organization/CREATE_DELIVERY_TARGET_RESPONSE';
export const CREATE_DELIVERY_TARGET_ERROR = 'Organization/CREATE_DELIVERY_TARGET_ERROR';

// UPDATE_DELIVERY_TARGET
export const UPDATE_DELIVERY_TARGET_REQUEST = 'Organization/UPDATE_DELIVERY_TARGET_REQUEST';
export const UPDATE_DELIVERY_TARGET_RESPONSE = 'Organization/UPDATE_DELIVERY_TARGET_RESPONSE';
export const UPDATE_DELIVERY_TARGET_ERROR = 'Organization/UPDATE_DELIVERY_TARGET_ERROR';
